import {
    apiRequest,
    riwayatGajiList,
} from "../../../../../services/adapters/kepegawaian/riwayatGajiService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", riwayatGajiList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
}

export default DataTableRepository